import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Loader from '../components/Loader';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
    flexDirection: 'row',
    maxWidth: 800,
    padding: 30,
  },
  radio: {
    padding: '0px 15px 15px 0',
  },
  searchContainer: {
    padding: '15px 0 0 30px',
  },
  textField: {
    marginRight: 50,
  },
  helperText: {
    fontSize: '.9rem',
    paddingBottom: 10,
  },
  label: {
    fontSize: '1.1rem',
    color: '#101010',
  },
});

const NumberSelector = props => {
  const {
    availablePhoneNumbers,
    isSearchingPhoneNumber,
    areaCode,
    hasSearchError,
    searchErrorMsg,
    handleChange,
    classes,
    selectedPhoneNumber,
    confirmPhoneNumber,
    cancelConfirmPhoneNumber,
    showPhoneNumberConfirmation,
    disableConfirm,
    handleChangeAreaCode,
    fetchNumbers,
  } = props;

  return (
    <div className={classes.root}>
      <Dialog
        open={showPhoneNumberConfirmation}
        onClose={cancelConfirmPhoneNumber}
        aria-labelledby="confirmation-alert"
        aria-describedby="confirm-selection"
        disableBackdropClick={true}
      >
        <DialogTitle id="alert-dialog-title">
          {'Confirm your selection'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your selected AgentBuzz phone number is {selectedPhoneNumber}.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={disableConfirm}
            onClick={cancelConfirmPhoneNumber}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            disabled={disableConfirm}
            onClick={confirmPhoneNumber}
            color="primary"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <FormControl
        component="fieldset"
        required
        className={classes.formControl}
      >
        <FormLabel className={classes.label}>
          Select a local phone number
        </FormLabel>
        <FormHelperText className={classes.helperText}>
          Your AgentBuzz phone number will be displayed on your sign riders and
          provides instant response when someone requests <br />info on your
          listings. AgentBuzz has local numbers in virtually every city in the
          U.S.
        </FormHelperText>
        <FormHelperText>
          * After you've selected and confirmed a local phone number, you'll not
          be able to change it. <br />You can contact support, if you would like
          to change it later.
        </FormHelperText>
        <div className={classes.searchContainer}>
          <TextField
            id="areaCode"
            label="Area Code"
            className={classes.textField}
            value={areaCode}
            onChange={handleChangeAreaCode}
            margin="normal"
          />
          <Button variant="outlined" color="primary" onClick={fetchNumbers}>
            Search
          </Button>
        </div>
        {isSearchingPhoneNumber ? (
          <Loader loaderText="Fetching available phone numbers..." />
        ) : hasSearchError ? (
          <h3>{searchErrorMsg}</h3>
        ) : (
          <RadioGroup
            aria-label="phone-number"
            name="phoneNumber"
            className={classes.group}
            value={selectedPhoneNumber}
            onChange={event =>
              handleChange('selectedPhoneNumber', event.target.value)
            }
          >
            {availablePhoneNumbers.map(number => {
              return (
                <FormControlLabel
                  value={number}
                  control={<Radio />}
                  label={number}
                  key={number}
                  className={classes.radio}
                />
              );
            })}
          </RadioGroup>
        )}
      </FormControl>
    </div>
  );
};

export default withRouter(withStyles(styles)(NumberSelector));



// WEBPACK FOOTER //
// ./src/components/NumberSelector.js